import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CallTagConstants } from 'src/app/store/samwin/call-tags/call-tag-constants';
import { LoadSpecificTagForHistoryMessage, UpdateCallTag } from 'src/app/store/samwin/call-tags/call-tags.actions';
import { CallTagsState } from 'src/app/store/samwin/call-tags/call-tags.state';
import { MessageInfo } from 'src/app/store/samwin/samwin-mail-list/message-info';

@Component({
   selector: 'samweb-email-category',
   templateUrl: './email-category.component.html',
   styleUrls: ['./email-category.component.scss'],
})
export class EmailCategoryComponent implements OnInit {
   @Input()
   public isInbox: boolean;

   @Input()
   public messageInfo: MessageInfo;

   public category$: Observable<string>;

   constructor(public store: Store) {}

   ngOnInit(): void {
      if (this.isInbox) {
         this.category$ = this.store
            .select(CallTagsState.getMessageTag)
            .pipe(map((getMessageTag) => getMessageTag(this.messageInfo.callId, this.messageInfo.messageId, CallTagConstants.CATEGORY_TAG)));
      } else {
         this.store.dispatch(new LoadSpecificTagForHistoryMessage(this.messageInfo.messageId, CallTagConstants.CATEGORY_TAG));
         this.category$ = this.store
            .select(CallTagsState.getHistoryMessageTag)
            .pipe(map((getHistoryMessageTag) => getHistoryMessageTag(this.messageInfo.messageId, CallTagConstants.CATEGORY_TAG)));
      }
   }

   changeSelectedCategory(value: string) {
      this.store.dispatch(new UpdateCallTag(this.messageInfo.callId, CallTagConstants.CATEGORY_TAG, value, this.messageInfo.messageId));
   }
}
